var React = require('react');

function Blog (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 2C1 1.44772 1.44772 1 2 1H8.36356C8.62878 1 8.88313 1.10536 9.07067 1.29289L14.7071 6.92933C14.8946 7.11687 15 7.37122 15 7.63644V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2Z","stroke":"#1A1D31","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8.77783 1V6.22222C8.77783 6.77451 9.22555 7.22222 9.77783 7.22222H15.0001","stroke":"#1A1D31","strokeWidth":"2","key":1})]);
}

Blog.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Blog;

Blog.default = Blog;
